import crypto from 'crypto'

function criptografar(content) {
    if(!content) {
        return null
    }
    
    try {
        const cipher = crypto.createCipher('aes-256-ctr', process.env.REACT_APP_CRYPTO_KEY)
        const crypted = cipher.update(content, 'utf8', 'hex')

        return crypted
    } catch(e) {
        return content
    }
}

function descriptografar(content) {
    if(!content) {
        return null
    }

    try {
        const decipher = crypto.createDecipher('aes-256-ctr', process.env.REACT_APP_CRYPTO_KEY)
        
        const decipheredText = decipher.update(content, 'hex', 'utf8')

        return JSON.parse(decipheredText)
    } catch(e) {
        return { error: true }
    }
}

export {
    criptografar,
    descriptografar
}
